import styled from 'styled-components';

import { spaceMixin, token } from '@zillow/constellation';

export const StyledBackgroundDiv = styled.div`
  background-color: ${token('colors.coolGray100')};
  padding: ${spaceMixin('sm')};
  cursor: pointer;
`;
